/**
 * Centralized allowlists for feature access (voice-test, etc.).
 *
 * CRE Chat / Protocols / modules are gated by `cre/crePermissions.js`
 * (`user.permissions` from Validate). Email allowlists for those modules
 * were removed per Jacky (CRE Web App permissions work).
 */

// ---- Voice-test (dev tooling; not a CRE license permission) ----
const VOICE_TEST_ALLOWED_EMAILS = [
  "faizanaslam.dev@gmail.com",
  "faizanaslam.workspace@gmail.com",
].map((e) => e.toLowerCase());

/**
 * Resolve email for voice-test allowlist (Wix / CRE / Radical).
 */
export function resolveVoiceTestUserEmail({
  isWixAuth,
  isCreAuth,
  isRadicalAuth,
  wixUser,
  creUser,
  radicalUser,
} = {}) {
  if (isWixAuth) return wixUser?.email ?? "";
  if (isCreAuth) return creUser?.email ?? "";
  if (isRadicalAuth) {
    return radicalUser?.email ?? radicalUser?.userEmail ?? "";
  }
  return "";
}

/**
 * Returns true if the current user may access the voice-test page.
 * In development, allowed for any authenticated session.
 */
export function isVoiceTestAllowedForUser({
  isWixAuth,
  isCreAuth,
  isRadicalAuth,
  wixUser,
  creUser,
  radicalUser,
} = {}) {
  if (process.env.NODE_ENV === "development") {
    return Boolean(isWixAuth || isCreAuth || isRadicalAuth);
  }

  const email = resolveVoiceTestUserEmail({
    isWixAuth,
    isCreAuth,
    isRadicalAuth,
    wixUser,
    creUser,
    radicalUser,
  });
  if (!email || typeof email !== "string") return false;
  return VOICE_TEST_ALLOWED_EMAILS.includes(email.trim().toLowerCase());
}

/**
 * Returns true if the current Wix user is allowed to access the voice-test page.
 */
export function isVoiceTestAllowedForWixUser(isWixAuth, email) {
  return isVoiceTestAllowedForUser({
    isWixAuth,
    isCreAuth: false,
    isRadicalAuth: false,
    wixUser: isWixAuth ? { email } : null,
  });
}
